import { IApplicationState } from '../../types/redux';
import { triggerHeaderShowNBConsultantPhone } from '../events/triggerHeaderShowNBConsultantPhone';
import { getRegionId } from '../../selectors/newbuilding';

export function displayConsultantPhone(state: IApplicationState, enabledRegions: number[], phone?: string | null) {
  const region = getRegionId(state);

  if (phone && !!region && enabledRegions.includes(region)) {
    triggerHeaderShowNBConsultantPhone(phone);
  }
}
